import { isNil } from 'lodash';
import { Text } from '@shared/components/Text';
import { SubformField } from '@shared/data/entity/fields/SubformField';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: SubformField;
}

export function SubformCollectionViewField({ field }: Props) {
  const { workflowTemplate: queriedWorkflowTemplate } = useWorkflowTemplate(
    isNil(field.workflowTemplate) ? field?.subform.workflowTemplateId : null,
  );
  const workflowTemplate = queriedWorkflowTemplate ?? field.workflowTemplate;

  if (isNil(workflowTemplate) || field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <Text size="body1">{workflowTemplate.name}</Text>
    </CardCollectionViewFieldContainer>
  );
}
